import { WILLS_PLAN_PRICE } from '@/constants'

import { UsState } from '@/components/EstimateWidget/FloatingVariation/FloatingForm/experiments/FinalExpenseInfoForm/utils/constants'

import {
  ATTORNEY_REVIEW_ELIGIBLE_STATES,
  WILLS_V3_12_TREATMENT_2_FLOW,
} from '@/hooks/features/useWillsFunnelFlow'

export const getPlanPrice = (
  isFakeDiscount = false,
  flow?: string,
  state?: string
) => {
  const fullEstatePlanPrice = WILLS_PLAN_PRICE.fullEstatePlanPrice
  const basicWillPlanPrice = WILLS_PLAN_PRICE.basicWillPlanPrice

  if (flow === WILLS_V3_12_TREATMENT_2_FLOW) {
    if (state && ATTORNEY_REVIEW_ELIGIBLE_STATES.includes(state as UsState)) {
      return {
        willPrice: 189,
        trustPrice: 399,
        willOriginalPrice: 199,
        trustOriginalPrice: 449,
        willDiscount: 10,
        trustDiscount: 50,
      }
    }
  }

  if (isFakeDiscount) {
    return {
      willPrice: basicWillPlanPrice,
      trustPrice: fullEstatePlanPrice,
      willOriginalPrice: 199,
      trustOriginalPrice: 449,
      willDiscount: 50,
      trustDiscount: 100,
    }
  }

  return {
    willPrice: basicWillPlanPrice,
    trustPrice: fullEstatePlanPrice,
    willOriginalPrice: undefined,
    trustOriginalPrice: undefined,
    willDiscount: undefined,
    trustDiscount: undefined,
  }
}
